<template>
  <BaseInputField
    class="form-input-field inherit--font"
    filled
    flat
    v-bind="$attrs"
    variant="outlined"
    @focus="() => (isFocused = true)"
    @blur="() => (isFocused = false)"
  >
    <template v-for="(_, name) in $slots" #[name]="slotData">
      <slot :name v-bind="slotData" />
    </template>
    <template v-if="required" #label>
      <span class="d-inline-flex align-center">
        {{ $attrs.label }} *
      </span>
    </template>
    <template v-else-if="tooltipContent" #label>
      <span class="d-inline-flex align-center">
        {{ $attrs.label }}
        <BaseTooltip max-width="270">
          <template #activator="{ on }">
            <v-icon
              size="20"
              class="ml-2 tooltip-activator"
              :color="isFocused ? 'inherit' : ''"
              v-on="on"
            >
              mdi-information
            </v-icon>
          </template>
          {{ tooltipContent }}
        </BaseTooltip>
      </span>
    </template>
    <template v-if="appendInnerContent" #append-inner>
      <div>{{ appendInnerContent }}</div>
    </template>
  </BaseInputField>
</template>
<script setup lang="ts">
import { ref, defineProps } from 'vue'
import { BaseInputField, BaseTooltip } from '@/components/base'

defineProps<{
  tooltipContent?: string
  appendInnerContent?: string
  required?: boolean
}>()

const $slots = defineSlots<Record<string, any>>()

const isFocused = ref(false)
</script>
<style scoped lang="scss">
.v-icon {
  margin-bottom: 2px;
}
.tooltip {
  border-radius: 0;
  &::before {
    content: '';
    position: absolute;
    top: 0;
    right: calc(50% - 4px);
    width: 10px;
    border-bottom: 8px solid transparent;
    border-left: 8px solid var(--v-black-base);
    transform: rotate(45deg) translateY(-50%);
  }
}
</style>
